import React, { useEffect } from "react";
import "./mainContent.css";
import ReactHtmlParser from 'react-html-parser';

export default function EachCard(props) {
  
  return (
    
      <a href={props.data.link}><div className="col m4 ">
          <div className="card each_home_card z-depth-1">
            <div className="card-image">
              <img src={props.data.full_path} />
            </div>
            <div className="card-content">
              <h6 class="black-text">{props.data.title}</h6>
              <p>{ReactHtmlParser(props.data.description)}</p>
            </div>
            
          </div>
      </div></a>
    
  );
}
